const ONLINE_BOOKING_DISABLED_CATEGORIES = [
    'branch.online_booking_disabled',
    'company.online_booking_disabled',
    'branch.has_no_data',
];

export const isOnlineBookingDisabledError = (error) =>
    !!error?.graphQLErrors?.some(
        (e) => ONLINE_BOOKING_DISABLED_CATEGORIES.includes(e.extensions?.category)
    );
